import '@babel/polyfill';
import './components/prototypes';
import './components/font-awesome';
import './components/object-fit';
import './components/contact-forms';
import './components/cards';
import './components/slider';
import './components/audio.js';
import './components/portals';
import './components/lightbox';
// import './components/validation';
import './components/donation';
import NavMenu from './components/nav-menu';
import WPLiveChatAriaFix from './components/wp-live-chat-aria';

import jQuery from 'jquery';
const $ = jQuery;
window.$ = jQuery;

import Cookies from 'js-cookie';
import Swiper from 'swiper';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.us';

window.onload = function() {
  WPLiveChatAriaFix();
  NavMenu();

  // Gallery Slider
  var swiper = new Swiper("#gallery", {
      slidesPerView: 4,
      spaceBetween: 20,
      slidesPerGroup: 4,
      loop: true,
      loopFillGroupWithBlank: true,
      pagination: {
      el: ".swiper-pagination",
      clickable: true
      },

      // Pagination
      navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
      },

      // Aria
      a11y: {
      prevSlideMessage: "Previous slide.",
      nextSlideMessage: "Next slide.",
      firstSlideMessage: "This is the first slide.",
      lasttSlideMessage: "This is the last slide."
      }
  });

  // Gallery
  function openImg(imgs) {
      var expandImg = document.getElementById("expandedImg");
      var imgText = document.getElementById("imgtext");
      expandImg.src = imgs.src;
      imgText.innerHTML = imgs.alt;
      expandImg.parentElement.style.display = "block";
  }

  // Phone Field
  var phoneInputs = document.querySelectorAll('.input__phone');

  if (phoneInputs && phoneInputs.length > 0) {
      for (var i = 0; i < phoneInputs.length; i++) {
          var phone = phoneInputs[i];

          new Cleave(phone, {
              numericOnly: true,
              blocks: [0, 3, 0, 3, 4],
              delimiters: ["(", ")", " ", "-"],
          });
      }
  }

  // Currency Format
  const donationField = document.getElementById('contribution');

  if (donationField) {
      const donationCleave = new Cleave('#contribution', {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          rawValueTrimPrefix: true,
          numeralIntegerScale: 7,
          numeralDecimalScale: 2,
      });
  }

  // Date Format
  const dateFields = document.querySelectorAll('.input__date');
  if ( dateFields && dateFields.length > 0 ) {
      for (var i=0; i < dateFields.length; i++) {
          var date = dateFields[i];
          new Cleave(date, {
              date: true,
              datePattern: ['m','d','Y']
          });
      }
  }

  // Donation Form
  const donationWishlistCheckbox = document.querySelector('#charitable_field_wishlist_element');
  const donationWishlistContent = document.querySelector('#charitable_field_wishlist_content');

  if (donationWishlistCheckbox && donationWishlistContent) {
      donationWishlistCheckbox.addEventListener("click", function(e) {
          var checked = donationWishlistCheckbox.checked;

          donationWishlistContent.classList.remove( checked ? 'd-none' : 'd-block' );
          donationWishlistContent.classList.add( checked ? 'd-block' : 'd-none' );

          console.dir(this, donationWishlistContent);
      });
  }

  // Get the button for disabling animations
  const disableAnim = document.getElementById('toggle-portals');

  // Set the default state of the disable animations cookie if it doesn't exist
  if (Cookies.get('disable_animations') === undefined) {
      Cookies.set('disable_animations', 'false');
  }

  // Check to see if the disable animation cookie exists
  let disableAnimations = Cookies.get('disable_animations');

  if (disableAnimations === 'true') {
      disableAnim.checked = true;
  }

  // Add the event listener
  disableAnim.addEventListener('click', toggleAnims);

  function toggleAnims() {
      if (disableAnim.checked) {
          Cookies.set('disable_animations', 'true');
          document.body.classList.add('no-animations');
      } else {
          Cookies.set('disable_animations', 'false');
          document.body.classList.remove('no-animations');
      }
  }
  toggleAnims();

}
